import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { usePageSeo } from '../hooks/usePageSeo';
import type { ForumBase } from '../types/forum';

interface Props {
  darkMode: boolean;
}

const TagForumsPage: React.FC<Props> = ({ darkMode }) => {
  const { tag } = useParams<{ tag: string }>();
  const [forums, setForums] = useState<ForumBase[]>([]);

  usePageSeo({
    title: `${tag} etiketli forumlar`,
    description: `${tag} etiketiyle işaretlenmiş forum siteleri.`,
    keywords: 'forum etiket',
    canonical: `/tag/${tag}`,
  });

  useEffect(() => {
    const t = (tag || '').toLowerCase();
    supabase
      .from('forums')
      .select('*')
      .eq('is_active', true)
      .then(({ data }) => {
        setForums(
          (data || []).filter((f) => (f.tags || []).some((x) => x.toLowerCase().includes(t)))
        );
      });
  }, [tag]);

  return (
    <div className={`min-h-screen ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <div className="container mx-auto px-4 py-8">
        <h1 className={`text-3xl font-bold mb-6 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
          #{tag} ({forums.length})
        </h1>
        <ul className="space-y-2">
          {forums.map((f) => (
            <li key={f.id}>
              <Link to={`/forum/${f.forum_id}`} className="text-indigo-500 hover:underline">
                {f.name}
              </Link>
            </li>
          ))}
        </ul>
        {!forums.length && (
          <p className={darkMode ? 'text-gray-500' : 'text-gray-500'}>
            Bu etiket için forum yok. Admin panelinden foruma tags[] ekleyebilirsiniz.
          </p>
        )}
      </div>
    </div>
  );
};

export default TagForumsPage;
